import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, managerOnly = false, editorOrManager = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="loading-screen">
        <Loader2 className="h-8 w-8 animate-spin text-[#FF7878]" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  const isManager = !!user?.role?.is_manager;
  const canManageInventory = isManager || !!user?.can_manage_inventory;
  if (managerOnly && !isManager) {
    return <Navigate to="/" replace />;
  }
  if (editorOrManager && !canManageInventory) {
    return <Navigate to="/" replace />;
  }
  return children;
}
